import Vue from "vue";
import Router from "vue-router";
import Login from "@/components/login";
import Nav from '@/components/login/nav';
import About from '@/components/about';
import Work from '@/components/work';
import Details from '@/components/work/details'



//import { store } from "../store/store.js";

var baseRoutes = [
  {
    path: "/",
    components: {
      default: Login,
      sidebar:Nav
    }
  },
  {
    path: "/about",
    components: {
      default: About,
      sidebar:Nav
    },
    meta: { transitionName: 'slide' },
  },
  {
    path: "/work",
    components: {
      default: Work,
      sidebar:Nav
    },
    meta: { transitionName: 'slide' },
  },
  {
    path: "/work/details/:id",
    components: {
      default: Details,
      sidebar:Nav
    },
    meta: { transitionName: 'slide' },
  },
  

];

const routes = baseRoutes

Vue.use(Router);

var router = new Router({
  mode: 'history',
  routes: routes
});

router.beforeEach((to, from, next) => {
  return next();
});

export default router;
